import React from 'react';
import PropTypes from 'prop-types';
import SsnInput from '@carvana/showroom-forms/Input/Ssn';

const SocialSecurityNumber = props => {
  const {
    error,
    id,
    label,
    mode,
    name,
    onBlur,
    onChange,
    touched,
    value,
    width
  } = props;

  return (
    <SsnInput
      label={label}
      id={id}
      onBlur={onBlur}
      onChange={onChange}
      touched={touched}
      error={error}
      value={value}
      name={name}
      width={width}
      mode={mode}
      className="fs-exclude"
    />
  );
};

SocialSecurityNumber.propTypes = {
  error: PropTypes.oneOfType([PropTypes.string, PropTypes.bool]),
  id: PropTypes.string,
  label: PropTypes.string,
  mode: PropTypes.string,
  name: PropTypes.string,
  onBlur: PropTypes.func,
  onChange: PropTypes.func,
  touched: PropTypes.bool,
  value: PropTypes.string.isRequired,
  width: PropTypes.number
};

SocialSecurityNumber.defaultProps = {
  error: false,
  id: null,
  label: 'Social security',
  mode: 'light',
  name: null,
  onBlur: () => {},
  onChange: () => {},
  touched: false,
  width: 300
};

export default SocialSecurityNumber;
